/**
 * @description Format named plan/invoice applied discounts for merchant UI.
 * LYN-250: two 10% rows render `Stacked (10% + 10%)`; one row renders `10%`.
 *
 * @param {Array<{value_type?: string, valueType?: string, value?: number}>} applied
 * @returns {string|null}
 * @dependencies None
 * @notes Uses value_type/value from the snapshot, not realized cents.
 */
export default function formatStackedDiscounts(applied) {
  if (!Array.isArray(applied) || applied.length === 0) {
    return null;
  }

  const labels = applied.map((row) => {
    const valueType = row.value_type || row.valueType;
    const value = Number(row.value);
    if (valueType === 'percentage' && Number.isFinite(value)) {
      return `${value}%`;
    }
    const cents = Number(row.amount_cents != null ? row.amount_cents : row.amountCents);
    if (Number.isFinite(cents)) {
      return `$${(cents / 100).toFixed(2)}`;
    }
    return row.title || 'Discount';
  });

  if (labels.length === 1) {
    return labels[0];
  }
  return `Stacked (${labels.join(' + ')})`;
}
